<template>
    <div class="lms__superadmin_users_profile_edit_learninghistory_external">
        <component-list
            ref="listlearninghistory"
            :component-grid="LmsSuperadminUsersProfileEditLearningHistoryExternalGrid"
            :component-table="LmsSuperadminUsersProfileEditLearningHistoryExternalTable"
            :component-table-name="'lms-superadmin-users-profile-edit-learning-history-external'"
            :filters-active="true"
            :filter-search-queryable="true"
            :get-pagination-getter="'getUserHistoryPagination'"
            :get-items-getter="'getUserHistory'"
            :get-items-dispatch="'getUserHistory'"
            :filter-search-placeholder="'Search external training'"
            :get-items-dispatch-data="{ learnerId: userId, type: 'externalTraining' }"
            :item-name="['external training record', 'external training records']"
        ></component-list>
    </div>
</template>

<script>
import ComponentList from '@/components/default/shared/ComponentList'
import LmsSuperadminUsersProfileEditLearningHistoryExternalTable from '@/components/lms/superadmin/users/profile/edit/LmsSuperadminUsersProfileEditLearningHistoryExternalTable'
import LmsSuperadminUsersProfileEditLearningHistoryExternalGrid from '@/components/lms/superadmin/users/profile/edit/LmsSuperadminUsersProfileEditLearningHistoryExternalGrid'

export default {
  name: 'lms-superadmin-users-profile-edit-learning-history-external',
  components: { ComponentList },
  data () {
    return {
      LmsSuperadminUsersProfileEditLearningHistoryExternalTable,
      LmsSuperadminUsersProfileEditLearningHistoryExternalGrid
    }
  },
  computed: {
    userId () {
      return this.$route.params.userId
    }
  },
  created () {
    this.$eventBus.$on('get-learning-history', () => {
      this.$refs.listlearninghistory.getItems()
    })
  },
  beforeDestroy () {
    this.$eventBus.$off('get-learning-history')
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/dashboard/list/_dashboardlistcompleteitems.scss";
</style>
